import { render, staticRenderFns } from "./commentList.vue?vue&type=template&id=7deffb5c&scoped=true&"
import script from "./commentList.vue?vue&type=script&lang=ts&"
export * from "./commentList.vue?vue&type=script&lang=ts&"
import style0 from "./commentList.vue?vue&type=style&index=0&id=7deffb5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7deffb5c",
  null
  
)

export default component.exports